import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_MULTI_NEW_ITEM_FOR_MULTI_QUERY = graphql(/* GraphQL */ `
	query discountMultiNewItemForMulti($hotelID: String!, $duplicateDiscountId: ID, $discountListHotelId2: ID!) {
		discountMultiNewItem(hotelID: $hotelID, duplicateDiscountID: $duplicateDiscountId) {
			name
			hotelID
			discountID
			discountCode
			inSale
			description
			isUncancelable
			saleTypeForPlan
			saleTypeForTerm
			saleStart
			saleEnd
			stayableStart
			stayableEnd
			stayableDayOfTheWeek
			discountPriceTotalLimit {
				currencyType
				amount
			}
			multiDiscounts
		}
		discountList(hotelID: $discountListHotelId2) {
			longTerm {
				id
				name
				discountID
			}
			ordinary {
				id
				name
				discountID
			}
		}
	}
`);
